import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import web from "../components/videos/vedio-3.mp4";

function HeroSection() {
    return (
        <>
            <div className="banner-section">
                <div className="container-fluid resVedio  ">
                        <div className="col-12 video-width">
                            <video autoPlay loop muted >
                                <source src={web} />
                            </video>
                        </div>
                    {/* <div className="row">

                        <div className="col-sm-12 col-lg-12 col-sm-lg">
                            <video autoPlay loop muted >
                                <source src={web} />
                            </video>
                        </div>

                    </div> */}
                </div>
            </div>
        </>






    );
}
export default HeroSection;

